import { Music2, ExternalLink } from "lucide-react";

function parseYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.slice(1);
    if (u.searchParams.get("v")) return u.searchParams.get("v");
    const m = u.pathname.match(/\/embed\/([^/]+)/);
    if (m) return m[1];
  } catch { /* ignore */ }
  return null;
}

function parseSpotify(url) {
  // returns {type, id} for tracks/albums/playlists
  try {
    const u = new URL(url);
    if (!u.hostname.includes("spotify.com")) return null;
    const parts = u.pathname.split("/").filter(Boolean);
    if (parts.length >= 2) return { type: parts[0], id: parts[1] };
  } catch { /* ignore */ }
  return null;
}

export default function MusicEmbed({ url, idx = 0 }) {
  if (!url) return null;
  const yt = parseYouTubeId(url);
  if (yt) {
    return (
      <div data-testid={`music-embed-${idx}`} className="card-mc overflow-hidden">
        <div className="aspect-video bg-black">
          <iframe
            title={`YouTube ${idx}`}
            src={`https://www.youtube.com/embed/${yt}`}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  const sp = parseSpotify(url);
  if (sp) {
    return (
      <div data-testid={`music-embed-${idx}`} className="card-mc overflow-hidden">
        <iframe
          title={`Spotify ${idx}`}
          src={`https://open.spotify.com/embed/${sp.type}/${sp.id}`}
          className="w-full h-[152px]"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        />
      </div>
    );
  }

  if (url.includes("soundcloud.com")) {
    return (
      <div data-testid={`music-embed-${idx}`} className="card-mc overflow-hidden">
        <iframe
          title={`SoundCloud ${idx}`}
          width="100%"
          height="166"
          scrolling="no"
          frameBorder="no"
          src={`https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23CE1126&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`}
        />
      </div>
    );
  }

  // Fallback: external link
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={`music-embed-${idx}`} className="card-mc p-4 flex items-center justify-between hover:border-foreground transition-colors">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[hsl(var(--secondary))] flex items-center justify-center rounded-sm">
          <Music2 className="w-5 h-5" />
        </div>
        <span className="text-sm font-medium truncate max-w-[260px]">{url}</span>
      </div>
      <ExternalLink className="w-4 h-4 text-muted-foreground" />
    </a>
  );
}
